import React, { useEffect } from 'react'
import ModalComponent from '../UI/Modal/Modal';
import { Button, DatePicker, Form } from 'antd';
import axiosInstance from '../../api/utils/axiosInstance';
import moment from 'moment';
import { toast } from 'react-toastify';

const YearPlanDeadlineModal = ({show, onHide, setIsLoading}) => {

    const [form] = Form.useForm();

    useEffect(()=> {
        const blockingFetch = async () => {
            setIsLoading(true)
            try{
                const res = await axiosInstance.get("/organizer/deadlines");
                console.log(res.data);
                if(res.status === 200){
                  form.setFieldValue("mainPlanDeadline", res.data.mainPlanDeadline.map(date => moment(date)));
                  form.setFieldValue("additionalPlanDeadline", res.data.additionalPlanDeadline.map(date => moment(date)));
                }
            }catch(e){
                const errMsg = e.response.data || "Dogodila se greška! Molimo provjerite unosene podatke i pokušajte ponovno.";
                toast.error(errMsg, {position: toast.POSITION.BOTTOM_RIGHT});
            }finally{
                setIsLoading(false);
            }
        }
        
        if(show) {
            blockingFetch();
        }
    },[show]);

    const rangeConfig = {
        rules: [
            {
            type: 'array',
            required: true,
            message: 'Obvezan podatak!',
            },
        ],
    };

    const onFinish = async (fieldsValue) => {
        setIsLoading(true);
        const mainPlanDeadline = fieldsValue['mainPlanDeadline'];
        const additionalPlanDeadline = fieldsValue['additionalPlanDeadline'];
        const values = {...fieldsValue}
        try{
            const res = await axiosInstance.post("/organizer/deadlines", values);
            if(res.status === 200){
                toast.success("Uspješno spremljeno", {position: toast.POSITION.BOTTOM_RIGHT});
            }
        }catch(e){
            const errMsg = e.response.data || "Dogodila se greška! Molimo provjerite unosene podatke i pokušajte ponovno.";
            toast.error(errMsg, {position: toast.POSITION.BOTTOM_RIGHT});
        }finally{
            setIsLoading(false);
            onHide();
        }
    }

  return (
    <ModalComponent show={show} onHide={onHide} size="m" title="Unos rokova za dostavu planova">
         <Form layout='vertical' form={form} onFinish={onFinish}>
            <Form.Item name={"mainPlanDeadline"} label="Razdoblje za dostavu godišnjeg plana"  {...rangeConfig}>
                <DatePicker.RangePicker format={"DD.MM.YYYY."}/>
            </Form.Item>

            <Form.Item name={"additionalPlanDeadline"} label="Razdoblje za dostavu dodatno pojedinačnog plana:"  {...rangeConfig}>
                <DatePicker.RangePicker format={"DD.MM.YYYY."}/>
            </Form.Item>

            <Form.Item>
                <div className="row-action-wrapper">
                    <Button type="danger" block={true} onClick={onHide}>Odustani</Button>
                    <Button type="primary" block={true} htmlType="submit">Spremi</Button>
                </div>
            </Form.Item>
         </Form>
    </ModalComponent>
  )
}

export default YearPlanDeadlineModal